module.exports = __webpack_public_path__ + "media/assets/services_manager/flags/russian-4cd499e32e9e81c4665f511901e7e493c7b56ad6637e04793613c021c041c64a.png";